// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"7b88a293","322":"4c4108d6","344":"611d6ebc","632":"b997ba98"}[chunkId] + ".chunk.css";
};